import { getDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
import { TOOL_TYPES } from './constants';
import { TOOL_REGISTRY } from './tools/registry';
import { findIconSiblings } from './tools/IconTool';
export function getToolType(field) {
  for (const [toolType, config] of Object.entries(TOOL_REGISTRY)) {
    if (config.matches(field)) {
      return toolType;
    }
  }
  return null;
}
function extractGroupNameFromPath(path) {
  const firstSegment = path[0];
  if (typeof firstSegment !== 'string') return null;
  const match = firstSegment.match(/^group(.+)$/);
  return match ? match[1] : null;
}
function getFieldValue(field, path, fieldOverrides) {
  const overrideValue = getDeepValue(fieldOverrides, path);
  if (overrideValue !== undefined) {
    return overrideValue;
  }
  return field.default;
}
function findToolbarFieldsInGroup(fields, fieldOverrides, basePath, processedPaths = new Set()) {
  const results = [];
  for (const field of fields) {
    const fieldPath = [...basePath, field.name];
    const fieldKey = fieldPath.join('.');
    if (processedPaths.has(fieldKey)) continue;
    const toolType = getToolType(field);
    if (toolType) {
      const info = {
        toolType,
        field,
        path: fieldPath,
        currentValue: getFieldValue(field, fieldPath, fieldOverrides)
      };
      if (toolType === TOOL_TYPES.ICON) {
        const siblings = findIconSiblings(fields, field, basePath, fieldOverrides);
        if (Object.keys(siblings).length > 0) {
          info.siblings = siblings;
          Object.values(siblings).forEach(s => processedPaths.add(s.path.join('.')));
        }
      }
      results.push(info);
    }
  }
  return results;
}
export function findToolbarFieldsForFocusedField(fields, fieldOverrides, focusedFieldPath) {
  const results = [];
  const parentPath = focusedFieldPath.slice(0, -1);
  const processedPaths = new Set();
  let targetFields = fields;
  for (const segment of parentPath) {
    if (typeof segment === 'string') {
      const group = targetFields.find(f => f.name === segment);
      if (group !== null && group !== void 0 && group.children) {
        targetFields = group.children;
      }
    }
  }
  results.push(...findToolbarFieldsInGroup(targetFields, fieldOverrides, parentPath, processedPaths));
  const siblingStyleGroup = targetFields.find(f => f.name === 'style' && f.type === 'group' && f.children);
  if (siblingStyleGroup !== null && siblingStyleGroup !== void 0 && siblingStyleGroup.children) {
    const stylePath = [...parentPath, 'style'];
    results.push(...findToolbarFieldsInGroup(siblingStyleGroup.children, fieldOverrides, stylePath, processedPaths));
  }
  const topLevelGroupStyle = fields.find(f => f.name === 'groupStyle' && f.type === 'group' && f.children);
  if (topLevelGroupStyle !== null && topLevelGroupStyle !== void 0 && topLevelGroupStyle.children) {
    results.push(...findToolbarFieldsInGroup(topLevelGroupStyle.children, fieldOverrides, ['groupStyle'], processedPaths));
    const groupName = extractGroupNameFromPath(focusedFieldPath);
    if (groupName) {
      const nestedStyleGroup = topLevelGroupStyle.children.find(f => f.name === `group${groupName}` && f.type === 'group' && f.children);
      if (nestedStyleGroup !== null && nestedStyleGroup !== void 0 && nestedStyleGroup.children) {
        const nestedPath = ['groupStyle', `group${groupName}`];
        results.push(...findToolbarFieldsInGroup(nestedStyleGroup.children, fieldOverrides, nestedPath, processedPaths));
      }
    }
  }
  return results;
}